"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabeledInputMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Input = require("../../components/Input/Input.styles");
var _Label = require("../../components/Label/Label.styles");
var _fontWeightMixin = require("../fontWeightMixin");
var _ie11Mixin = require("../ie11Mixin");
var _typographyMixin = require("../typographyMixin");
var labelExpandCSS = function labelExpandCSS(props) {
  return (0, _styledToken.default)({
    fontTypeInput: 'LabeledInput.fontTypeInput',
    transition: 'LabeledInput.transition',
    horizontalSpacing: 'LabeledInput.horizontalSpacing'
  }, function (_ref) {
    var fontTypeInput = _ref.fontTypeInput,
      transition = _ref.transition,
      horizontalSpacing = _ref.horizontalSpacing;
    return (0, _styledComponents.css)(["", " position:absolute;left:", "px;top:50%;transform:translateY(-50%);transform-origin:left top;transition:", ";pointer-events:none;"], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontTypeInput
    }, props)), horizontalSpacing, transition);
  })(props);
};
var labelShrinkCSS = function labelShrinkCSS(props) {
  return (0, _styledToken.default)({
    fontTypeLabel: 'LabeledInput.fontTypeLabel',
    scale: 'LabeledInput.scale'
  }, function (_ref2) {
    var fontTypeLabel = _ref2.fontTypeLabel,
      scale = _ref2.scale;
    return (0, _styledComponents.css)(["transform:translateY(-100%) scale(", ");font-weight:", ";"], scale, (0, _fontWeightMixin.fontWeightMixin)(fontTypeLabel));
  })(props);
};
var labelCSS = function labelCSS(props) {
  return (0, _styledComponents.css)(["> ", "{", " ", "}> ", ":focus,> ", ":not(:placeholder-shown),> ", ":-webkit-autofill{& ~ ", "{", "}}", "[readonly]{& ~ ", "{left:0;}}"], _Label.StyledLabel, labelExpandCSS(props), (0, _ie11Mixin.ie11Mixin)(labelShrinkCSS(props)), _Input.StyledInput, _Input.StyledInput, _Input.StyledInput, _Label.StyledLabel, labelShrinkCSS(props), _Input.StyledInput, _Label.StyledLabel);
};
var inputCSS = function inputCSS(props) {
  return (0, _styledToken.default)({
    transition: 'LabeledInput.transition',
    paddingBase: 'LabeledInput.paddingBase',
    verticalSpacing: 'LabeledInput.verticalSpacing'
  }, function (_ref3) {
    var transition = _ref3.transition,
      paddingBase = _ref3.paddingBase,
      verticalSpacing = _ref3.verticalSpacing;
    return (0, _styledComponents.css)(["> ", "{padding-top:", "px;padding-bottom:", "px;transition:", ";&::placeholder{transition:", ";}&:not(:focus)::placeholder{color:transparent;}}"], _Input.StyledInput, paddingBase + verticalSpacing, paddingBase - verticalSpacing, transition, transition);
  })(props);
};

/** @class LabeledInputMixin */
/** @method */
var LabeledInputMixin = function LabeledInputMixin(props) {
  return (0, _styledComponents.css)(["position:relative;", " ", ""], labelCSS(props), inputCSS(props));
};
exports.LabeledInputMixin = LabeledInputMixin;